// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.innovation {
  bottom: 50%;
  right: -10%;
}

.news-scroll-box {
  max-height: 80px;
  padding: 30px;
  padding-top: 25px !important;
  height: auto;
  width: 100%;
  margin: 0;
  outline: 2px solid white;
  transition: 0.5s;
  cursor: pointer;
  overflow: hidden;
}

.article-toggle {
  width: 40px;
  height: 40px;
}
@media (max-width: 500px) {
  .article-toggle {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 500px) {
  h1 {
    font-size: 1em;
  }
  h3 {
    font-size: 1em;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/careers/internships/internships.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;AAAE;EAHF;IAII,WAAA;IACA,YAAA;EAGF;AACF;;AAAA;EACE;IACE,cAAA;EAGF;EADA;IACE,cAAA;EAGF;AACF","sourcesContent":[".innovation {\r\n  bottom: 50%;\r\n  right: -10%;\r\n}\r\n\r\n.news-scroll-box {\r\n  max-height: 80px;\r\n  padding: 30px;\r\n  padding-top: 25px !important;\r\n  height: auto;\r\n  width: 100%;\r\n  margin: 0;\r\n  outline: 2px solid white;\r\n  transition: .5s;\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n}\r\n\r\n.article-toggle {\r\n  width: 40px;\r\n  height: 40px;\r\n  @media (max-width:500px) {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width:500px) {\r\n  h1 {\r\n    font-size: 1em;\r\n  }\r\n  h3 {\r\n    font-size: 1em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
